/**
 * @generated SignedSource<<a16c518690407521c9fa84b493a27419>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActiveProductContextQuery$variables = {
  organizationSlug: string;
  productSlug: string;
  skip: boolean;
};
export type ActiveProductContextQuery$data = {
  readonly product?: {
    readonly " $fragmentSpreads": FragmentRefs<"ActiveProductContextFragment" | "ActiveProductContext_useProductSlugHistoryRedirect">;
  } | null;
};
export type ActiveProductContextQuery = {
  response: ActiveProductContextQuery$data;
  variables: ActiveProductContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organizationSlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productSlug"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = {
  "kind": "Variable",
  "name": "slug",
  "variableName": "productSlug"
},
v4 = [
  {
    "kind": "Variable",
    "name": "organizationSlug",
    "variableName": "organizationSlug"
  },
  (v3/*: any*/)
],
v5 = [
  (v3/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v12 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v9/*: any*/),
  (v11/*: any*/)
],
v13 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v9/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActiveProductContextQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ActiveProductContextFragment"
              },
              {
                "args": (v5/*: any*/),
                "kind": "FragmentSpread",
                "name": "ActiveProductContext_useProductSlugHistoryRedirect"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActiveProductContextQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "Product",
            "kind": "LinkedField",
            "name": "product",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registrationAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endsAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cover",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "richEditorCheckoutDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landingPageUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creationDatetime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMembersAppVisibleToAll",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LandingPage",
                "kind": "LinkedField",
                "name": "landingPage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaTitle",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaDescription",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "metaImageUrl",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "typeTag",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "label",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Badge",
                "kind": "LinkedField",
                "name": "badge",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "color",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "emoji",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaUrl",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "memberId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Curriculum",
                "kind": "LinkedField",
                "name": "curriculum",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "showCompletedUsers",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "modules",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsage",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isReleased",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerHasCompleted",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "kind",
                    "value": "custom"
                  }
                ],
                "concreteType": "MemberGroupNodeConnection",
                "kind": "LinkedField",
                "name": "memberGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  }
                ],
                "storageKey": "memberGroups(kind:\"custom\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Occurrence",
                "kind": "LinkedField",
                "name": "nextOrLastOccurrence",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "datetimeRange",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Dashboard",
                "kind": "LinkedField",
                "name": "dashboard",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "layout",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tmpAllowExternalRegistrations",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "adminCanLearnMode",
                "storageKey": null
              },
              {
                "alias": "connectedApps",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "includeNested",
                    "value": true
                  }
                ],
                "concreteType": "ProductAppNodeConnection",
                "kind": "LinkedField",
                "name": "productApps",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductAppNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProductApp",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "productApps(includeNested:true)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waitingRoomEndsAt",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nonNullProductId",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ],
                    "type": "Product",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "Event",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Comment",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Feed",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Post",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": "nullableProductIdString",
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productId",
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      (v11/*: any*/)
                    ],
                    "type": "ContentUsage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "ChatChannel",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v13/*: any*/),
                    "type": "Dashboard",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v12/*: any*/),
                    "type": "AssignmentSubmission",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "PathwayGroup",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v10/*: any*/),
                    "type": "BrainSearch",
                    "abstractKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "registrationType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waitlistUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "waitlistCtaLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasEnded",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductApplication",
                "kind": "LinkedField",
                "name": "viewerApplication",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "SlugHistory",
                "kind": "LinkedField",
                "name": "historicalSlug",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "occurrenceId",
                    "storageKey": null
                  },
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "3f5adf723399ef44ad07b5f102c53d0a",
    "id": null,
    "metadata": {},
    "name": "ActiveProductContextQuery",
    "operationKind": "query",
    "text": "query ActiveProductContextQuery(\n  $productSlug: String!\n  $organizationSlug: String!\n  $skip: Boolean!\n) {\n  product(slug: $productSlug, organizationSlug: $organizationSlug) @skip(if: $skip) {\n    ...ActiveProductContextFragment\n    ...ActiveProductContext_useProductSlugHistoryRedirect_z2SvB\n    id\n  }\n}\n\nfragment ActiveProductContextFragment on Product {\n  id\n  name\n  slug\n  type\n  status\n  registrationAvailability\n  startDate\n  endDate\n  startsAt\n  endsAt\n  cover\n  description\n  richEditorCheckoutDescription\n  landingPageUrl\n  creationDatetime\n  isMembersAppVisibleToAll\n  landingPage {\n    mode\n    metaTitle\n    metaDescription\n    metaImageUrl\n    id\n  }\n  typeTag {\n    label\n    id\n  }\n  badge {\n    id\n    kind\n    icon\n    color\n    emoji\n    mediaUrl\n    ...BadgeFragment\n  }\n  viewerMembership {\n    id\n    memberId\n    role\n  }\n  curriculum {\n    id\n    showCompletedUsers\n    ...ContentModuleUtils_useCurriculumModuleIdsFragment\n    ...ContentModuleUtils_useOnCurriculumModuleCompletedFragment\n  }\n  memberGroups(kind: custom) {\n    totalCount\n  }\n  nextOrLastOccurrence {\n    id\n    datetimeRange\n  }\n  dashboard {\n    id\n    layout\n  }\n  tmpAllowExternalRegistrations\n  adminCanLearnMode\n  ...appLevelContextFragment\n  ...useIsWaitingRoomEnabledActiveProductFragment\n  ...ProductRegistrationButtonActiveProductFragment\n  ...usePermissionsFragment\n  ...useConnectedProductAppsActiveProductFragment\n  ...ExperienceHeader_ProductFragment\n  ...HeaderContent_ProductAppsFragment\n  ...ProductBadgeFragment\n  ...PathwayPageHeaderFragment\n  ...LearnModeSwitchFragment\n}\n\nfragment ActiveProductContext_useProductSlugHistoryRedirect_z2SvB on Product {\n  slug\n  historicalSlug(slug: $productSlug) {\n    occurrenceId\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ContentModuleUtils_useCurriculumModuleIdsFragment on Curriculum {\n  id\n  modules {\n    edges {\n      node {\n        id\n        isReleased\n        contentId\n      }\n    }\n  }\n}\n\nfragment ContentModuleUtils_useOnCurriculumModuleCompletedFragment on Curriculum {\n  id\n  modules {\n    edges {\n      node {\n        id\n        viewerHasCompleted\n      }\n    }\n  }\n}\n\nfragment DeletePathwayButton_productFragment on Product {\n  id\n  name\n  type\n  ...usePermissionsFragment\n}\n\nfragment ExperienceAdminDropdownFragment on Product {\n  id\n  slug\n  type\n  name\n  adminCanLearnMode\n  ...LearnModeSwitchFragment\n  ...usePermissionsFragment\n}\n\nfragment ExperienceHeader_ProductFragment on Product {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  ...ExperienceAdminDropdownFragment\n}\n\nfragment HeaderContent_ProductAppsFragment on Product {\n  id\n  ...ExperienceAdminDropdownFragment\n  badge {\n    ...BadgeFragment\n    id\n  }\n  ...LearnModeSwitchFragment\n}\n\nfragment LearnModeSwitchFragment on Product {\n  id\n  name\n  status\n  viewerMembership {\n    id\n  }\n}\n\nfragment PathwayAdminDropdownFragment on Product {\n  id\n  slug\n  ...usePermissionsFragment\n  ...usePathwayAdminDropdownItemsFragment\n}\n\nfragment PathwayPageHeaderFragment on Product {\n  ...PathwayAdminDropdownFragment\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment ProductRegistrationButtonActiveProductFragment on Product {\n  registrationAvailability\n  registrationType\n  waitlistUrl\n  waitlistCtaLabel\n  hasEnded\n  viewerApplication {\n    status\n    id\n  }\n}\n\nfragment appLevelContextFragment on Product {\n  id\n  name\n  slug\n  type\n  ...useConnectedProductAppsActiveProductFragment\n}\n\nfragment useConnectedProductAppsActiveProductFragment on Product {\n  connectedApps: productApps(includeNested: true) {\n    edges {\n      node {\n        id\n        kind\n      }\n    }\n  }\n}\n\nfragment useIsWaitingRoomEnabledActiveProductFragment on Product {\n  waitingRoomEndsAt\n  startDate\n  ...usePermissionsFragment\n}\n\nfragment usePathwayAdminDropdownItemsFragment on Product {\n  id\n  slug\n  ...usePermissionsFragment\n  ...DeletePathwayButton_productFragment\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "eacf37d05fd128ae9525928417f26ba3";

export default node;
